import React, { useState } from "react";
import { motion } from "framer-motion";
import logo from "../logo.png";
import { Link } from "react-router-dom";
import menuIcon from "../menu.png";

const navItems = [
  { label: "Da Vittorio", path: "/" },
  { label: "Prenota", path: "/prenota" },
  { label: "Tariffe", path: "/tariffe" },
  // { label: "Snack-Bar", path: "/snack-bar" },
  { label: "Regolamento", path: "/regolamento" },
  { label: "Contatti", path: "/contatti" },
];

const NavbarWhite = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <motion.nav
      initial={{ opacity: 0, y: -50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
      className="w-full fixed top-0 left-0 z-50 p-6 bg-white text-black shadow-md transition-all duration-300"
    >
      <div className="max-w-7xl mx-auto flex justify-between items-center">
        {/* Logo */}
        <Link to="/" className="flex items-center">
          <img
            src={logo}
            alt="Da Vittorio Logo"
            className="h-12 w-auto cursor-pointer"
          />
        </Link>

        {/* Desktop Menu */}
        <ul
          className="hidden lg:flex gap-10 text-sm md:text-base lg:text-lg font-medium tracking-wide text-inherit"
          style={{ fontFamily: "Chivo, sans-serif" }}
        >
          {navItems.map((item, index) => (
            <li
              key={index}
              className="relative cursor-pointer transition duration-300 hover:text-[#009FB7]
              after:content-[''] after:absolute after:left-0 after:bottom-0 after:w-0 after:h-[2px] after:bg-[#009FB7] 
              after:transition-all after:duration-300 hover:after:w-full"
            >
              <Link to={item.path}>{item.label}</Link>
            </li>
          ))}
        </ul>

        {/* Hamburger Button (Mobile) */}
        <div className="lg:hidden z-30">
          <button onClick={() => setIsOpen(!isOpen)} className="focus:outline-none">
            <img src={menuIcon} alt="Menu" className="h-8 w-8 object-contain" />
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        className={`lg:hidden fixed top-0 left-0 w-full h-full bg-black bg-opacity-80 z-20 transform ${
          isOpen ? "translate-x-0" : "-translate-x-full"
        } transition-transform duration-300`}
      >
        <div
          className="flex flex-col items-center justify-center h-full space-y-6 text-white text-2xl"
          style={{ fontFamily: "Chivo, sans-serif" }}
        >
          {navItems.map((item, index) => (
            <Link
              key={index}
              to={item.path}
              onClick={() => setIsOpen(false)}
              className="cursor-pointer hover:text-[#009FB7] transition duration-300"
            >
              {item.label}
            </Link>
          ))}
        </div>
      </div>
    </motion.nav>
  );
};

export default NavbarWhite;
